import { render } from "./RouteCost.vue?vue&type=template&id=148baafd&scoped=true"
import script from "./RouteCost.vue?vue&type=script&lang=js"
export * from "./RouteCost.vue?vue&type=script&lang=js"

import "./RouteCost.vue?vue&type=style&index=0&id=148baafd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148baafd"]])

export default __exports__